import React, { useRef } from 'react';
import { useFrame } from '@react-three/fiber';
import { useTexture } from '@react-three/drei';
import { Mesh } from 'three';
import { useSatelliteStore } from '../../store/satelliteStore';
import { HIGH_PERFORMANCE_THRESHOLD } from './SatelliteMarker';

const Earth: React.FC = () => {
  const earthRef = useRef<Mesh>(null);
  const cloudsRef = useRef<Mesh>(null);
  const [earthTexture, cloudsTexture, normalTexture, specularTexture] = useTexture([
    '/textures/earth_daymap.jpg',
    '/textures/earth_clouds.jpg',
    '/textures/earth_normal_map.jpg',
    '/textures/earth_specular_map.jpg'
  ]);
  const objectLimit = useSatelliteStore(state => state.objectLimit);
  const disableAnimations = objectLimit > HIGH_PERFORMANCE_THRESHOLD;

  useFrame((state, delta) => {
    if (!disableAnimations) {
      if (earthRef.current) {
        earthRef.current.rotation.y += 0.0005;
      }
      if (cloudsRef.current) {
        cloudsRef.current.rotation.y += 0.0007;
      }
    }
  });

  return (
    <group>
      {/* Earth */}
      <mesh ref={earthRef}>
        <sphereGeometry args={[1, 64, 64]} />
        <meshPhongMaterial
          map={earthTexture}
          normalMap={normalTexture}
          specularMap={specularTexture}
          shininess={5}
        />
      </mesh>

      {/* Clouds */}
      <mesh ref={cloudsRef}>
        <sphereGeometry args={[1.003, 64, 64]} />
        <meshPhongMaterial
          map={cloudsTexture}
          transparent={true}
          opacity={0.3}
          depthWrite={false}
        />
      </mesh>

      {/* Atmosphere glow */}
      <mesh>
        <sphereGeometry args={[1.02, 64, 64]} />
        <meshPhongMaterial
          color="#4F46E5"
          transparent={true}
          opacity={0.03}
          depthWrite={false}
        />
      </mesh>
    </group>
  );
};

export default Earth; 